var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomOut2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.43487 8.53846L7.45155 9.55379L3.447 13.5641H5.3134V15H1V10.6923H2.4378V12.5413L6.43487 8.53846ZM9.56513 8.53846L13.5622 12.5413V10.6923H15V15H10.6866V13.5641H12.553L8.54845 9.55379L9.56513 8.53846ZM15 1V5.30769H13.5622V3.4587L9.56513 7.46154L8.54845 6.44621L12.553 2.4359H10.6866V1H15ZM5.3134 1V2.4359H3.447L7.45155 6.44621L6.43487 7.46154L2.4378 3.4587V5.30769H1V1H5.3134Z",
    fill: "#303C49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut2);
export default __webpack_public_path__ + "static/media/zoom-out-2.39a4f8fafd0bbffd9bc23be958fd0724.svg";
export { ForwardRef as ReactComponent };